export const environment = {
  production: true
};



// WEBPACK FOOTER //
// C:/Users/Dtuck/Desktop/projects/Javascript/metacritic-rebuild/src/environments/environment.ts